PJQ.views.projects.AutoReport = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Auto-Report'),
        minWidth: '800px'
    },
    events: {
        'click .export-pdf': 'exportPDF'
    },
    afterRender: function() {
        // fetch and display the report contents (in HTML format)
        let loader = new PJQ.Loader(this.$('div.report-content'));
        new PJQ.ajax.Request({
            endpoint: PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'autoreport'
                }
            ])
        }).get().done(_.bind(function (response) {
            loader.remove();
            jQuery('div.report-content').html(atob(response.data));
            jQuery('div.report-content div div table tbody tr td[width="100%"]').attr('width', '0px');
        }, this));
    },
    exportPDF: function() {
        // export the report to PDF and serve up the download.
        PJQ.files.downloadFile(
            PJQ.helpers.urlHelpers.generateEndpoint([
                {
                    endpoint: 'projects',
                    value: PJQ.app.session.project.id
                },
                {
                    endpoint: 'autoreport'
                },
                {
                    endpoint: 'export'
                }
            ])
        );
    }
});

PJQ.views.projects.BulkExport = PJQ.views.BaseModal.extend({
    defaults: {
        template: new PJQ.templating.Template(PJQ.constants.modules.PROJECTWALL, 'Modal-Bulk-Export'),
        minWidth: '600px',
        info: null,
        onExport: _.noop(),
        onCancel: _.noop()
    },
    events: {
        'click .export-pdf': 'exportPDF',
        'click .cancel-export': 'cancelExport'
    },
    renderData: function () {
        return {
            items: this.options.info != null ? this.options.info.get('items') : [],
        };
    },
    afterRender: function() {
        if (this.options.info == null)
            return;

        // we cannot export if there are no items that have data
        if (_.size(_.filter(this.options.info.get('items'), function(item) { return item.count > 0 })) == 0) {
           this.$('.export-pdf').prop('disabled', true);
        }
    },
    cancelExport: function() {
        if (typeof this.options.onCancel === 'function') {
            this.options.onCancel();
        }
        this.removeModal();
    },
    exportPDF: function() {
        var includedCount = 0;
        _.each(this.$('.export-item'), _.bind(function(itemInput) {
            if ($(itemInput).prop('checked'))
                includedCount++;

            this.options.info.get('items')[$(itemInput).data('itemIndex')].include = $(itemInput).prop('checked');
        }, this));

        if (includedCount == 0) {
            new PJQ.views.BaseModal({
                header: "Project Bulk Export Error",
                body: 'Please select at least one Report to include.',
                isShowCancelButton: false
            });
            return;
        }

        let email = this.$('.export-email').val();
        if (!PJQ.helpers.validators.validateEmail(email, true).success) {
            new PJQ.views.BaseModal({
                header: "Project Bulk Export Error",
                body: 'Please enter a valid email address',
                isShowCancelButton: false
            });
            return;
        }
        this.options.info.set('email', email);

        this.options.info.save(null, {
            success: _.bind(function () {
                new PJQ.views.BaseModal({
                    header: "Project Bulk Export",
                    body: 'Your export request is being processed.  An email with the report attached will be sent to the recipient(s) listed in the Email field.',
                    isShowCancelButton: false,
                    onOk: _.bind(function () {
                        if (typeof this.options.onExport === 'function') {
                            this.options.onExport();
                        }
                        this.removeModal();
                    }, this)
                });
            }, this)
        });

    }
});